import useAuth from '../../../hooks/use-auth/use-auth';
import constantsFactory from '../../../utils/constants';
import Icon from '../../atoms/Icon/Icon';
import colors from '../../theme/constants/colors';
import Props from './typings';

const starIcon = {
  a: 'star',
  b: 'star-outline',
} as const;

// TODO: once system is moved to APP, revert some of the changes as dynamic import will be no longer used
const PromotionStar: React.FC<Props> = ({type}) => {
  const auth = useAuth();
  const {ROLES} = constantsFactory();

  return (
    <>
      {auth.isAuthorised([ROLES.STAFF]) && (type === 'a' || type === 'b') && (
        <Icon type={starIcon[type]} fontSize={14} color={colors.darkBlue50} />
      )}
    </>
  );
};

export default PromotionStar;
